import React from 'react';
import { StickyNote } from 'lucide-react';
import { WhatsAppInternalNote } from '@/services/integrations/whatsappInboxService';
import { useUsers } from '@/contexts/UsersContext';
import { formatRelativeTime } from '@/utils/whatsappInbox';

/** Internal notes are visually distinct (amber, full-width, never inline with
 * customer/agent bubbles) and carry an explicit "not sent to WhatsApp" label —
 * scope.txt §12 treats this as a hard requirement, not a nice-to-have. */
const InternalNoteBubble: React.FC<{ note: WhatsAppInternalNote }> = ({ note }) => {
  const { users } = useUsers();
  const author = users.find((u) => u.uuid === note.user_uuid)?.userName || 'Team member';

  return (
    <div className="flex justify-center px-0 py-0.5">
      <div className="max-w-[620px] w-full rounded-lg bg-amber-50 border border-amber-200 border-l-[3px] border-l-amber-500 px-3.5 py-2.5">
        <div className="flex items-center gap-1.5 mb-1">
          <StickyNote className="w-3 h-3 text-amber-700" />
          <span className="text-[10.5px] font-extrabold text-amber-800 tracking-wide">
            INTERNAL NOTE · NOT SENT TO WHATSAPP
          </span>
        </div>
        <div className="text-[12.5px] leading-relaxed text-amber-900 whitespace-pre-wrap">{note.note_text}</div>
        <div className="text-[10.5px] text-amber-700 mt-1.5">{author} · {formatRelativeTime(note.created_at)}</div>
      </div>
    </div>
  );
};

export default InternalNoteBubble;
